export default {"src":"/_next/static/media/minidiftman-zoom.45d38762.svg","height":73,"width":73,"blurWidth":0,"blurHeight":0};